import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const createNewUnitPremisesRoute: RouteConfig<'with-page'> = {
    name: 'Create New Unit',
    path: '/unit-premises/new',
    context: 'member',
    page: lazy(() => import('.')),
    flags: ['member-route'],
}